import type { ListBuilderList } from '../../../types';

/**
 * Has Disciplinary Action list - licenses with an active disciplinary
 * record requiring immediate attention.
 *
 * The list ID stays `default-licenses-at-risk` so existing dashboard
 * navigation links and saved filter URLs keep working.
 */
export const atRiskList: ListBuilderList = {
	id: 'default-licenses-at-risk',
	cacheTTL: 300000,
	name: 'Has Disciplinary Action',
	type: 'default',
	active: true,
	sortOrder: 4,
	filterRules: {
		licenseHasDisciplinary: {
			defaultValue: { id: 'yes', label: 'Yes' },
			locked: true,
			hidden: true,
		},
		licenseSalesRep: {
			defaultValue: [{ id: 'ME', label: 'Me' }],
			applyDefaultIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			lockedIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
			hiddenIf: {
				type: 'group',
				joiner: 'AND',
				negated: false,
				children: [
					{ type: 'rule', action: 'licenses:view:any', negated: true },
				],
			},
		},
	},
	inheritsFrom: 'default-licenses-all',
};
